export default __webpack_public_path__ + "static/academic-background-346113c6dd4635ab0e0721159bb77620.jpeg";